import { Workbook } from 'exceljs';

import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

export const onExporting = (e: any, date: string) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('1');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
    topLeftCell: { row: 3, column: 1 },
  })
    .then(() => {
      // header
      const headerRow1 = worksheet.getRow(1);
      const headerRow2 = worksheet.getRow(2);

      worksheet.mergeCells(1, 1, 1, 8);
      worksheet.mergeCells(2, 1, 2, 8);

      headerRow1.getCell(1).value = 'Сверка по карьерам';
      headerRow1.getCell(1).font = { bold: true };
      headerRow1.getCell(1).alignment = { horizontal: 'center' };

      headerRow2.getCell(1).value = `В период: ${date}`;
      headerRow2.getCell(1).font = { bold: true };
      headerRow2.getCell(1).alignment = { horizontal: 'center' };
    })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
  e.cancel = true;
};
